import * as process from 'process'

const win = window as any
win.process = process
export { createSmartHub as create } from './app'
